import React from 'react';
import { Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from './styles/theme';
import { SectionTitle, DataTable } from './components';

const styles = StyleSheet.create({
  container: {
    paddingBottom: spacing.lg,
  },
  rowContainer: {
    flexDirection: 'row',
    marginTop: spacing.md,
  },
  tableColumn: {
    width: '40%',
    paddingRight: spacing.md,
  },
  mapColumn: {
    width: '60%',
    paddingLeft: spacing.md,
  },
  mapContainer: {
    borderWidth: 1,
    borderColor: colors.border.light,
    borderStyle: 'solid',
    padding: spacing.sm,
    backgroundColor: colors.background.white,
  },
  mapImage: {
    width: '100%',
    height: 160,
  },
  mapCaption: {
    ...typography.caption,
    marginTop: spacing.sm,
    textAlign: 'center',
  },
  legendContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: spacing.sm,
    paddingTop: spacing.sm,
    borderTopWidth: 1,
    borderTopColor: colors.border.light,
    borderTopStyle: 'solid',
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: spacing.sm,
  },
  legendColor: {
    width: 12,
    height: 8,
    marginRight: 4,
  },
  legendText: {
    fontSize: 7,
    color: colors.text.muted,
  },
});

// Table columns configuration
const countryColumns = [
  {
    key: 'label',
    header: 'País',
    flex: 1,
    render: (row) => row.label,
  },
  {
    key: 'value',
    header: 'Espectadores',
    width: 80,
    align: 'right',
    render: (row) => row.value.toLocaleString(),
  },
];

const Page4 = ({ c4 = null, countries = [] }) => {
  return (
    <View style={styles.container}>
      <SectionTitle
        title="Distribución Mundial"
        subtitle="Ubicación geográfica de los espectadores"
      />

      <View style={styles.rowContainer}>
        {/* Countries Table */}
        <View style={styles.tableColumn}>
          <DataTable
            columns={countryColumns}
            data={countries}
            variant="compact"
            maxRows={10}
          />
        </View>

        {/* World Map */}
        <View style={styles.mapColumn}>
          <View style={styles.mapContainer}>
            {c4 && <Image style={styles.mapImage} src={c4} />}
            <Text style={styles.mapCaption}>
              Mapa de calor con las ubicaciones desde las cuales se sintonizó la
              transmisión.
            </Text>

            {/* Legend */}
            <View style={styles.legendContainer}>
              <View style={styles.legendItem}>
                <View
                  style={[styles.legendColor, { backgroundColor: '#c6dbef' }]}
                />
                <Text style={styles.legendText}>Bajo</Text>
              </View>
              <View style={styles.legendItem}>
                <View
                  style={[styles.legendColor, { backgroundColor: '#6baed6' }]}
                />
                <Text style={styles.legendText}>Medio</Text>
              </View>
              <View style={styles.legendItem}>
                <View
                  style={[styles.legendColor, { backgroundColor: '#2171b5' }]}
                />
                <Text style={styles.legendText}>Alto</Text>
              </View>
              <View style={styles.legendItem}>
                <View
                  style={[styles.legendColor, { backgroundColor: '#084594' }]}
                />
                <Text style={styles.legendText}>Muy Alto</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default Page4;
